export enum Channel {
  DIRECT = 'direct',
  EMAIL = 'email',
  EMBED = 'embed',
  ORGANIC = 'organic',
  PAID_SEARCH = 'paid_search',
  PAID_SOCIAL = 'paid_social',
  SOCIAL = 'social',
}

type ChannelInputs = {
  fbclid?: string | null;
  gclid?: string | null;
  msclkid?: string | null;
  referrer?: string | null;
  utmMedium?: string | null;
  utmSource?: string | null;
};

const SOCIAL_HOSTS = [
  'facebook',
  'instagram',
  'fb.',
  't.co',
  'twitter',
  'x.com',
  'linkedin',
  'pinterest',
  'reddit',
  'tiktok',
  'youtube',
  'snapchat',
];
const SEARCH_HOSTS = ['google', 'bing', 'yahoo', 'duckduckgo', 'ecosia', 'baidu', 'yandex', 'ask.', 'aol.'];

const hostFromReferrer = (referrer: string | null | undefined): string => {
  if (!referrer) {
    return '';
  }
  try {
    return new URL(referrer).hostname.toLowerCase();
  } catch {
    return '';
  }
};

const channelFromMedium = (medium: string): Channel | undefined => {
  if (medium.includes('social')) return Channel.PAID_SOCIAL;
  if (medium.includes('paid') || medium.includes('display') || ['cpc', 'ppc', 'sem'].includes(medium)) {
    return Channel.PAID_SEARCH;
  }
  if (medium.includes('email')) return Channel.EMAIL;
  if (['seo', 'organic', 'article'].includes(medium)) return Channel.ORGANIC;
  return undefined;
};

export const deriveChannel = ({ fbclid, gclid, msclkid, referrer, utmMedium, utmSource }: ChannelInputs): Channel => {
  if (gclid || msclkid) return Channel.PAID_SEARCH;
  if (fbclid) return Channel.PAID_SOCIAL;

  const fromMedium = channelFromMedium((utmMedium ?? '').toLowerCase().replace(/[\s_+-]/g, ''));
  if (fromMedium) return fromMedium;

  const host = hostFromReferrer(referrer);
  if (SEARCH_HOSTS.some((h) => host.includes(h))) return Channel.ORGANIC;
  if (SOCIAL_HOSTS.some((h) => host.includes(h) || (utmSource ?? '').toLowerCase().includes(h))) return Channel.SOCIAL;

  return Channel.DIRECT;
};

const PAID_CHANNELS = new Set<Channel>([Channel.PAID_SEARCH, Channel.PAID_SOCIAL]);

export const isAdCampaign = (channel?: Channel | null): boolean => !!channel && PAID_CHANNELS.has(channel);
